import { forwardRef } from 'react';
import { VisxText } from '@/components/VisxText';
import { capitalize } from 'lodash';

interface Props {
  title: string;
  value: string;
  x: number;
  color: string;
}

const Valuation = forwardRef<SVGSVGElement, Props>(
  ({ title, x, value, color }, ref) => {
    return (
      <svg x={`${x * 100}%`} y={0} width="100%" ref={ref}>
        <VisxText
          verticalAnchor="start"
          textAnchor="start"
          fill={color}
          typography="xLargeStrong"
        >
          {value}
        </VisxText>
        <VisxText
          y={24}
          verticalAnchor="start"
          textAnchor="start"
          fill={color}
          typography="xSmallStrong"
        >
          {capitalize(title)}
        </VisxText>
      </svg>
    );
  }
);

Valuation.displayName = 'Valuation';

export default Valuation;
